var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRateCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.5368 23.5333L26.4549 1.45139C25.5313 0.52778 24.2543 0 22.9301 0H4.99976C2.24777 0 0 2.25249 0 4.99976V22.9301C0 24.2543 0.523055 25.5313 1.47494 26.4549L23.5568 48.5368C25.5077 50.4877 28.6838 50.4877 30.6347 48.5368L48.5651 30.6065C50.516 28.6556 50.516 25.503 48.5415 23.5286L48.5368 23.5333ZM11.2483 15.004C9.17487 15.004 7.49729 13.3264 7.49729 11.253C7.49729 9.17958 9.17487 7.502 11.2483 7.502C13.3217 7.502 14.9993 9.17958 14.9993 11.253C14.9993 13.3264 13.3217 15.004 11.2483 15.004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateCard);
export default __webpack_public_path__ + "static/media/RateCard.9afacccd3b6c48d5af4c431864dcc792.svg";
export { ForwardRef as ReactComponent };